// app/javascript/compcalc/components/AppWithTheme.jsx

import React from "react";
import PropTypes from "prop-types";

import { BrowserRouter as Router, RouteIndex, Route, Routes, Link, Redirect } from 'react-router-dom'

import indigo from '@material-ui/core/colors/indigo';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Button from '@material-ui/core/Button';

import PDRatings from './PDRatings'
// import EarnCalc from './EarnCalc'
import PermDisability from './PermDisability'
import Commutation from './Commutation'
import TempDisability from './TempDisability'
import LifePension from './LifePension'
import PVCalc from './PVCalc'
import LifeExpectancy from './LifeExpectancy'
import JobDisplacement from './JobDisplacement'
import DeathBenefits from './DeathBenefits'
import DateCalc from './DateCalc'
import QME from './QME'
import CombinedValue from './CombinedValue'
import Support from './Support'
import About from './About'

import App from './App'

require('./Config.js');


const theme = createTheme({
  body: {
    margin: 20,
  },

  typography: {
    useNextVariants: true,
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      global.config.isAIG ? 'AIG-Source-Sans-Pro' : 
        global.config.isCAAA ? 'Montserrat' : 
        global.config.isCompCalc ? 'Roboto' :
        'Neue-Haas-Unica-Light',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },

  palette: {
    primary: 
      global.config.isCompCalc ? indigo : 
      global.config.isAIG ? { main: '#003D7C' } : 
      global.config.isCAAA ? { main: '#060E43' } : 
      global.config.isNational ? { main: '#193D67', contrastText: '#FFFFFF' } :
      { main: '#071d49', contrastText: '#e9bf1d' }, // Matrix

    secondary: global.config.isNational ? { main: '#f6f6f9' } : pink,
    error: red,
    // type: 'dark',

    // Used by `getContrastText()` to maximize the contrast between the background and the text.
    contrastThreshold: 3,

    // Used to shift a color's luminance by approximately two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,

    // divider: '#D7D6D5',

    background: {
      // paper: '#fff',
      default: "#eeeeee"
    },

    // typography: {
    //   // Use the system font over Roboto.
    //   fontFamily: 'Avenir Next, Roboto, "Helvetica Neue", Arial, sans-serif',
    //   htmlFontSize: 16,
    // },
  },
});


class AppWithTheme extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      clipboard: '',
    }
  }

  componentDidMount = () => {
    document.getElementById('splash').remove();
  }

  copyToClipboard = (text) => {
    this.setState({ clipboard: text });
  }

  setPdfData = (data) => {
    this.pdfData = data
  }

  setChildMenuHandler = (handler) => {
    this.childMenuHandler = handler;
  }

  menuHandler = (menu, submenu, parameter) => {
    if (typeof(this.childMenuHandler) == 'function')
      this.childMenuHandler(menu, submenu, parameter);
  }

  render() {
    const { classes } = this.props;
    return(
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Router>
          <App 
                clipboard={ this.state.clipboard } 
                pdfData={ this.state.pdfData } 
                copyToClipboard={ this.copyToClipboard } 
                menuHandler={ this.menuHandler } 
                { ...this.props }>
            <Routes>
              { ['/', 'pdr/'].map(path => <Route exact path={path} key={path} element={
                <PDRatings
                  copyToClipboard={ this.copyToClipboard }
                  setPdfData={ this.setPdfData }
                  setChildMenuHandler={ this.setChildMenuHandler }
                  { ...this.props }/>
                }/> )
              }
              {/* <Route path="wage" component={ EarnCalc } />  */}
              <Route exact path="/pd" element={ <PermDisability /> } />
              <Route exact path="/td" element={
                <TempDisability 
                  copyToClipboard={ this.copyToClipboard }
                  setChildMenuHandler={ this.setChildMenuHandler }
                  { ...this.props }/>
              }/>
              <Route exact path="/comm" element={
                <Commutation 
                  copyToClipboard={ this.copyToClipboard }
                  setChildMenuHandler={ this.setChildMenuHandler }
                  {... this.props}/>
              }/>
              <Route exact path="/lp" element={ <LifePension /> } />
              <Route exact path="/le" element={ <LifeExpectancy /> } />
              <Route exact path="/jd" element={ <JobDisplacement /> } />
              <Route exact path="/db" element={ <DeathBenefits /> } />
              <Route exact path="/qme" element={ <QME /> } />
              <Route exact path="/date" element={ <DateCalc /> } />
              <Route exact path="/pv" element={
                <PVCalc
                  copyToClipboard={ this.copyToClipboard }
                  setChildMenuHandler={ this.setChildMenuHandler }
                  {... this.props}/>
              }/>
              <Route exact path="/cve" element={
                <CombinedValue
                  setChildMenuHandler={ this.setChildMenuHandler }
                  {... this.props}/>
              }/>
              <Route exact path="/support" element={ <Support /> } />
              <Route exact path="/about" element={ <About /> } />
              {/* Catch all other routes: */}
              {/* <Route path="*" component={NotFound} status={404} /> */}
            </Routes>
          </App>
        </Router>
      </MuiThemeProvider>
    );
  }
};

export default AppWithTheme;
